<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list detalhe-container">
    <div class="detalhe-header">
      <div class="integracao-info">
        <h1 class="title-default">Dados da Integração Scanntech</h1>
        <p class="welcome-message">
          <button mat-icon-button class="btn-voltar" (click)="voltar()" matTooltip="Voltar" aria-label="Voltar">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Acompanhe vendas, fechamentos, logs e reprocessamentos da integração.
        </p>
      </div>

      <div class="header-actions">
        <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="acoesMenu">
          <span>Ações</span>
          @if (quantidadeSelecionadaAbaAtiva > 0) {
            <span>({{ quantidadeSelecionadaAbaAtiva }})</span>
          }
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>

        <mat-menu #acoesMenu="matMenu">
          <span
            class="menu-tooltip-wrapper"
            [matTooltip]="hintHabilitarReprocessamento"
            [matTooltipDisabled]="quantidadeSelecionadaParaHabilitarAbaAtiva > 0">
            <button
              mat-menu-item
              [disabled]="quantidadeSelecionadaParaHabilitarAbaAtiva === 0"
              (click)="marcarSelecionadosReprocessamento()">
              <mat-icon>sync</mat-icon>
              <span>Habilitar reprocessamento</span>
            </button>
          </span>
          <span
            class="menu-tooltip-wrapper"
            [matTooltip]="hintDesabilitarReprocessamento"
            [matTooltipDisabled]="quantidadeSelecionadaParaDesabilitarAbaAtiva > 0">
            <button
              mat-menu-item
              [disabled]="quantidadeSelecionadaParaDesabilitarAbaAtiva === 0"
              (click)="desmarcarSelecionadosReprocessamento()">
              <mat-icon>close</mat-icon>
              <span>Desabilitar reprocessamento</span>
            </button>
          </span>
        </mat-menu>
      </div>
    </div>

    <mat-tab-group [(selectedIndex)]="abaAtivaIndex" (selectedIndexChange)="onAbaChange($event)" class="detalhe-tabs"
      appTabsScroll [mat-stretch-tabs]="false" [disablePagination]="true">
      <mat-tab label="Vendas">
        <div class="aba-conteudo">
          <app-aba-vendas [ativa]="abaVendasAtiva"></app-aba-vendas>
        </div>
      </mat-tab>

      <mat-tab label="Fechamentos">
        <div class="aba-conteudo">
          <app-aba-fechamentos [ativa]="abaFechamentosAtiva"></app-aba-fechamentos>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
